import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "cookie_notice_dismissed";

export default function CookieNotice() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissed = localStorage.getItem(KEY);
        if (!dismissed) {
            // small delay so it doesn't jump in on first paint
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const dismiss = () => {
        localStorage.setItem(KEY, "true");
        setVisible(false);
    };

    const { pathname } = useLocation();
    const onPrintPage = pathname.startsWith("/print/");

    if (!visible) return null;

    return (
        <div
            className={`fixed ${onPrintPage ? "bottom-24" : "bottom-3"} md:bottom-6 left-3 right-3 sm:left-auto sm:right-6 sm:max-w-md z-[60] fade-up`}
            data-testid="cookie-notice"
        >
            <div className="bg-[#1A1A1A] text-[#F2F0E9] p-4 sm:p-6 shadow-2xl border border-white/10 rounded">
                <div className="flex items-start gap-4">
                    <div className="flex-1">
                        <div className="label-caps text-[#8C3A3A] mb-2 hidden sm:block">Cookies</div>
                        <p className="text-xs sm:text-sm leading-relaxed text-[#E5E1D6]">
                            <span className="sm:hidden">Essential cookies only — for your cart and secure payments. </span>
                            <span className="hidden sm:inline">This site uses only the essentials — to remember your cart and to process payments securely.
                            No advertising trackers. </span>See our{" "}
                            <Link
                                to="/privacy"
                                onClick={dismiss}
                                className="underline hover:text-[#F2F0E9]"
                                data-testid="cookie-privacy-link"
                            >
                                Privacy Policy
                            </Link>.
                        </p>
                        <button
                            onClick={dismiss}
                            className="mt-3 sm:mt-4 bg-[#F2F0E9] text-[#1A1A1A] px-5 sm:px-6 py-2 rounded-full text-xs tracking-[0.2em] uppercase font-medium hover:bg-[#8C3A3A] hover:text-white transition-colors"
                            data-testid="cookie-accept-btn"
                        >
                            Got it
                        </button>
                    </div>
                    <button
                        onClick={dismiss}
                        className="text-[#A3A3A3] hover:text-[#F2F0E9] transition-colors p-1"
                        aria-label="Dismiss cookie notice"
                        data-testid="cookie-close-btn"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
